module.exports = __webpack_public_path__ + "static/img/03994671.5b8bf603.png";